var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5735 39.375L8.75 48.125V13.125C8.75 12.5448 8.98047 11.9884 9.3907 11.5782C9.80094 11.168 10.3573 10.9375 10.9375 10.9375H45.9375C46.5177 10.9375 47.0741 11.168 47.4843 11.5782C47.8945 11.9884 48.125 12.5448 48.125 13.125V37.1875C48.125 37.7677 47.8945 38.3241 47.4843 38.7343C47.0741 39.1445 46.5177 39.375 45.9375 39.375H19.5735Z",
    stroke: "#4E7661",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 39.375V50.3125C21.875 50.8927 22.1055 51.4491 22.5157 51.8593C22.9259 52.2695 23.4823 52.5 24.0625 52.5H50.4266L61.25 61.25V26.25C61.25 25.6698 61.0195 25.1134 60.6093 24.7032C60.1991 24.293 59.6427 24.0625 59.0625 24.0625H48.125",
    stroke: "#4E7661",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.cb3625c8220ad30deba9afee61ef3d69.svg";
export { ForwardRef as ReactComponent };